(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.es = {}));
  }(this, (function (exports) { 'use strict';
  
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined
        ? window.flatpickr
        : {
            l10ns: {},
        };
    var Spanish = {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            longhand: [
                "domingo",
                "lunes",
                "martes",
                "miércoles",
                "jueves",
                "viernes",
                "sábado",
            ],
        },
        months: {
            shorthand: [
                "ene",
                "feb",
                "mar",
                "abr",
                "may",
                "jun",
                "jul",
                "ago",
                "sep",
                "oct",
                "nov",
                "dic",
            ],
            longhand: [
                "enero",
                "febrero",
                "marzo",
                "abril",
                "mayo",
                "junio",
                "julio",
                "agosto",
                "septiembre",
                "octubre",
                "noviembre",
                "diciembre",
            ],
        },
        ordinal: function (nth) {
            return "º";
        },
        rangeSeparator: " a ",
        weekAbbreviation: "Sem",
        scrollTitle: "Desplazar para aumentar el valor",
        toggleTitle: "Hacer clic para alternar",
        time_24hr: true,
    };
    fp.l10ns.es = Spanish;
    var es = fp.l10ns;
  
    exports.Spanish = Spanish;
    exports.default = es;
  
    Object.defineProperty(exports, '__esModule', { value: true });
  
  })));